import { Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Injectable({
    providedIn:'root'
})
export class SeoService{
    constructor(
    private titleService: Title, 
    private metaService: Meta
) {}

  /**
   * Set the page title
   * @param title - The title of the page
   */
  setTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  /**
   * Set the meta description for the page
   * @param description - The description of the page
   */
  setDescription(description: string): void {
    this.metaService.updateTag({ name: 'description', content: description });
  }

  /**
   * Set the meta keywords for the page
   * @param keywords - The keywords for the page
   */
  setKeywords(keywords: string): void {
    this.metaService.updateTag({ name: 'keywords', content: keywords });
  }

  /**
   * Set the canonical URL for the page
   * @param url - The canonical URL of the page
   */
  setCanonicalUrl(url: string): void {
    this.metaService.updateTag({ rel: 'canonical', href: url });
  }

  /**
   * Set Open Graph (OG) tags for social media sharing
   * @param config - Object containing OG tags (title, description, image, url)
   */
  setOpenGraphTags(config: {
    title: string;
    description: string;
    image: string;
    url: string;
  }): void {
    this.metaService.updateTag({ property: 'og:title', content: config.title });
    this.metaService.updateTag({
      property: 'og:description',
      content: config.description,
    });
    this.metaService.updateTag({ property: 'og:image', content: config.image });
    this.metaService.updateTag({ property: 'og:url', content: config.url });
  }

  /**
   * Set Twitter Card tags for Twitter sharing
   * @param config - Object containing Twitter Card tags (title, description, image)
   */
  setTwitterCardTags(config: {
    title: string;
    description: string;
    image: string;
  }): void {
    this.metaService.updateTag({
      name: 'twitter:title',
      content: config.title,
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content: config.description,
    });
    this.metaService.updateTag({
      name: 'twitter:image',
      content: config.image,
    });
  }

  /**
   * Set the logo for SEO (using schema.org markup)
   * @param logoUrl - The URL of the logo
   */
  setLogo(logoUrl: string): void {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      logo: logoUrl,
    };
    this.metaService.updateTag({
      name: 'organization-logo',
      content: JSON.stringify(schema),
    });
  }
}